import { render } from "./PanelManager.vue?vue&type=template&id=946c96b2"
import script from "./PanelManager.vue?vue&type=script&lang=js"
export * from "./PanelManager.vue?vue&type=script&lang=js"

import "./PanelManager.vue?vue&type=style&index=0&id=946c96b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__